import { statuses } from '../../themes/'

export default {
	edit: {
		cursor: 'pointer',
		fontSize: '20px'
	},
	status: {
		...statuses
	},
	asap: {
		color: '#D0021B',
		fontWeight: 'bold'
	},
	late: {
		...statuses['ERRORED'],
		fontWeight: 'bold'
	}
}
